import { Component, EventEmitter, Input, Output, OnInit ,ElementRef,AfterViewInit,ViewChild,Renderer2 ,SimpleChanges} from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-report-table',
  templateUrl: 'report-table.component.html',
  styleUrls: [
    './report-table.component.scss',
  ]
})
export class ReportTableComponent implements OnInit {
    @ViewChild('tableWrapper') tableWrapper!: ElementRef;
    @Input() pageType: string="";
    @Input() rows: any;
    @Input() currentRoute: string;
    @Input() totalElements: number;
    @Input() pageNumber: number;
    @Input() pageSize: number;
    @Output() stopCodeClicked = new EventEmitter<string>();
    @Input() mode: string;
    @Output() paging1 = new EventEmitter<number>();
    @Output() pageChange = new EventEmitter<any>();
    isLoading:boolean=false;
    sortField: string = '';
    sortDirection: string = '';
     pages: number[] = []; 
    allData: any[] = []; 
     maxVisiblePages = 5;

    @Output() paging = new EventEmitter<{
      pageNumber: number;
      pageSize:number;
      sortField?: string;
      sortDirection?: string;
    }>();
    constructor(
      private router: Router,
      private renderer: Renderer2
      
    ) { 

    }

    ngOnInit(): void {
      window.dispatchEvent(new Event('resize'));

        }
  ngOnChanges(changes: SimpleChanges): void {
    
    if (
      (changes['totalElements'] && this.totalElements !== 0) ||
      (changes['pageSize'] && this.pageSize) ||
      (changes['pageNumber'] && this.pageNumber)
    ) {
      this.updatePageNav();
    }
     if (changes['pageSize']) {
    this.pageSize = Number(changes['pageSize'].currentValue);
  }
    
  }
    get displayPageNumber(): number {
      return this.totalElements === 0 ? 0 : this.pageNumber;
    }
    routeCustomer(customerId) {
      this.router.navigate([this.currentRoute + '/customer/' + customerId]);
    }

    routeDepartment(data) {
      this.router.navigate([this.currentRoute + '/department/' + data.departmentCode + '/' + data.customerCode]);
    }

    routeEmployee(data) {
      this.router.navigate([this.currentRoute + '/employee/' + data.employeeCode + '/' + data.customerCode + '/' + data.departmentCode]); 
    }
  
 changePage (pageInfo: any) {
         if (typeof pageInfo === 'number') {
              this.pageNumber=pageInfo;
        }
         if (pageInfo?.offset!== undefined) {
              this.pageNumber=pageInfo?.offset;
        }
          const pageNumber = pageInfo.offset;
          this.paging.emit({
            pageNumber: pageNumber,
            pageSize: this.pageSize,
            sortField: this.sortField,
            sortDirection: this.sortDirection
          });
            setTimeout(() => {
          this.tableWrapper.nativeElement.scrollTop = 0;
        });
      }

   onSort(event: any) {
    
        if (event.sorts && event.sorts.length > 0) {
           const latestSort = event.sorts[0];
          this.sortField = latestSort.prop;
          this.sortDirection = latestSort.dir; 
        } else {
          this.sortField = '';
          this.sortDirection = '';
        }

      this.changePage({ offset: 1});
      }

    setPage(event: any): void {
      
      this.pageChange.emit(event); 
    }
    scollPageEvent(event: any): void {
      this.pageChange.emit(event); 
    }
     routeStopGL(data){
    this.stopCodeClicked.emit(data.stopCode);  
    }

     routeStopWO(data) {
      this.router.navigate([this.currentRoute + '/stop/'  + data.employeeCode + '/' + data.customerCode + '/' + data.departmentCode +'/' + data.stopCode]); 
    }
   

    get totalPages(): number {
        return this.pageSize ? Math.ceil(this.totalElements / this.pageSize) : 1;
        
      }

      emitPaging() {
        this.paging.emit({
          pageNumber: this.pageNumber,
          pageSize: this.pageSize,
          sortField: this.sortField,
          sortDirection: this.sortDirection
        });
      }

      updateData(rows: any[], total: number) {
        this.rows = rows;
        this.totalElements = total;
        this.updatePageNav();
      }

      updatePageNav() {
        
        const total = this.totalPages;
        const half = Math.floor(this.maxVisiblePages / 2);

        let start = this.pageNumber - half;
        let end = this.pageNumber + half;

        if (start <= 0) {
          start = 1;
          end=5;
        }

        if (end >= total) {
          end = total ;
          start = Math.max(0, end - this.maxVisiblePages + 1);
        }

        this.pages = [];
        if(start===0){
          start=1;
        }
        for (let i = start; i <= end; i++) {
          this.pages.push(i);
        }
      }

      goToPage(p: number) {
        
        if (p < 0 || p >this.totalPages) return;
        this.pageNumber = p;
        this.emitPaging();
        this.updatePageNav();
      }

      prev() {
        if (this.pageNumber === 0) return;
        this.goToPage(this.pageNumber - 1);
      }

      next() {
        
        if (this.pageNumber+1  > this.totalPages) return;
        this.goToPage(this.pageNumber+1);
      }

      changePageSize(size: number) {
        this.pageSize = size;
        localStorage.setItem("pageSize",this.pageSize.toString());
        this.pageNumber = 1;
        this.emitPaging();
        this.updatePageNav();
      }
      first() {
      if (this.pageNumber === 1) return;
      this.goToPage(1);
    }

    last() {
      
      if (this.pageNumber === this.totalPages) return;
      this.goToPage(this.totalPages);
    }
}